import { render, staticRenderFns } from "./FileContent.vue?vue&type=template&id=e3ef386e&"
import script from "./FileContent.vue?vue&type=script&lang=ts&"
export * from "./FileContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports